import React from 'react';
import {
  BrowserRouter, Redirect, Switch, Route
} from "react-router-dom";
// import 'antd/dist/antd.css';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { ActionCreators } from './redux/actions';

import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';

import Landing from './pages/Landing';
import TNC from './pages/TNC';
import FAQ from './pages/FAQ';

import AirDrop from './pages/airdrop';

import NotFound from './components/NotFound';
import StakingHome from './pages/StakingHome';
import StakingSelect from './pages/StakingSelect';
import StakingConfirm from './pages/StakingConfirm';


class AppRoute extends React.PureComponent {
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <PublicRoute restricted path="/" component={Landing} exact />
          <PublicRoute restricted path="/tnc" component={TNC} exact />
          <PublicRoute restricted path="/faq" component={FAQ} exact />

          <PublicRoute restricted path="/storing" component={StakingHome} exact />
          <PublicRoute restricted path="/storing/store" component={StakingSelect} exact />
          <PublicRoute restricted path="/storing/confirm" component={StakingConfirm} exact />

          <PublicRoute restricted path="/airdrop" component={AirDrop} exact />
          <Route restricted path="/404" component={NotFound} exact />

          {/* <Redirect from="/" to="/" /> */}

          <Redirect exact from="/*" to="/404" />
        </Switch>
      </BrowserRouter>
    )
  }
}

function mapStateToProps(state) {
  return { ...state };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppRoute);
